(ns dashboard.views.recommendation.recommend-analysis
  (:require ["react" :as react]
            [clojure.set :as set]
            [dashboard.entity.analysis.answers :as analysis.answers]
            [dashboard.entity.analysis.applied-db :as applied.db]
            [dashboard.entity.analysis.db :as analysis.db]
            [dashboard.entity.analysis.search :as analysis.search]
            [dashboard.entity.analysis.tree :as analysis.tree]
            [dashboard.entity.recommendation.profile :as recommendations]))

;; ----------------------------------------------------------------------------
;;  Recommend Analysis : Step 1
;; ----------------------------------------------------------------------------

(defn- RecommendAnalysis-1-SelectAnalysis
  [{:keys [analyses-with-answers
           preselected-construct-ids
           question
           path
           selected-question
           set-selected-analysis
           use-hierarchy-context
           set-use-hierarchy-context]}]
  [:div.recommend-analysis--content
   [:div.recommender--step
    [:f> recommendations/ProcessSteps
     "Select an Analysis to base your Answer from"
     [:div
      [:p [:b "Step 1:"] " Click to select an analysis to build your Answer from"]
      [:p "In the next step, you will select from previous answers that been responded to using the selected analysis."]]
     "Build Answer from Similar Analysis"
     :recommended-analysis-process
     [{:class :is-info}
      {:disabled true
       :class :is-tertiary}
      {:disabled true
       :class :is-tertiary}]]]
   [:div.recommend-analysis--analysis-search.recommender--step
    [:h6.is-5.title.mt-0.mb-4.pb-2
     "Step 1: Select an Analysis with Associated Answers "]
    [:f> analysis.search/AnalysisSearch
     {:row-component analysis.tree/ListItemAnalysisRow
      :question question
      :hide-initial-search true
      :preselected-version-ids (->> selected-question
                                    :analyses
                                    (remove (comp preselected-construct-ids
                                                  :construct-id))
                                    (mapv :version-id)
                                    set)
      :search-actions [:f> analysis.search/QuestionFilterOptions
                       {:use-hierarchy-context use-hierarchy-context
                        :set-use-hierarchy-context set-use-hierarchy-context
                        :perform-search (fn []
                                          (analysis.search/perform-search
                                           {:path path
                                            :mode :semantic}
                                           (:content question))
                                          (analysis.search/set-search-query
                                           path
                                           (:content question)))
                        :question question}]
      :analyses analyses-with-answers
      :filter-actions [:div.tag.is-success.ml-2.is-light.search-control--buttons
                       [:b
                        [:i.icon.fas.fa-circle-exclamation.mr-2]
                        "Displaying Anaysis with Associated Answers Only"]]
      :path path
      :category nil
      :on-click-construct (fn [_ asa]
                            (set-selected-analysis asa))
      :initial-search {:query (:content question)
                       :mode :semantic}
      :selected-version-ids #{}
      :on-select identity
      :use-hierarchy-context use-hierarchy-context
      :set-use-hierarchy-context set-use-hierarchy-context}]]])

;; ----------------------------------------------------------------------------
;;  Recommend Analysis : Step 2
;; ----------------------------------------------------------------------------

(defn- RecommendAnalysis-2-SelectAnswerWithAppliedSelectedAnalysis
  [{:keys [linked-answers
           question
           on-question-selected
           selected-analysis
           set-selected-analysis
           step-fn]}]
  [:div.recommend-analysis--content
   [:div.level-left.my-0.is-align-items-flex-start
    [:div.is-flex-grow-1
     [:f> recommendations/ProcessSteps
      "Choose the most appropriate Answer Associated to the Analysis"
      [:div
       [:p [:b "Step " ((or step-fn identity) 2) ":"] " Click to select an Associated Answer."]
       [:p "Choose from the list of other questions and answers, that we will use to build this response from."]]
      "Build Answer from Similar Analysis"
      :recommended-analysis-process
      [(when-not step-fn
         {:class :is-secondary
          :on-click #(set-selected-analysis nil)})
       {:class :is-info}
       {:disabled true
        :class :is-tertiary}]]]]
   [:div.level-left.recommender--step
    (when-not step-fn
      [:button.button.is-secondary.mr-4.mt-2
       {:on-click #(set-selected-analysis nil)}
       [:i.icon.fas.fa-caret-left]])
    [:div.is-flex-grow-1
     [:h6.is-5.title.mb-0.mt-3
      "Step "
      ((or step-fn identity) 2)
      ": Select a Question and Answer"]
     [:f> analysis.answers/AssociatedAnswers
      (->> selected-analysis
           :applied-analyses
           first)
      (->> selected-analysis
           :applied-analyses)
      (fn [_] nil) ; On version click - used for ASA profile
      linked-answers
      on-question-selected
      question]]]])

;; ----------------------------------------------------------------------------
;;  Recommend Analysis : Step 3
;; ----------------------------------------------------------------------------

(defn- RecommendAnalysis-3-FillAnswerWithSelectedQuestion
    [{:keys [set-selected-analysis
             selected-question
             set-selected-question
             selected-question-analysis
             recommended-analyses
             on-question-selected
             on-submit
             preselected-construct-ids
             question
             all-analysis
             checked
             set-checked
             step-fn]}]
    (let [[answer-options
           set-answer-options] (react/useState
                                {:response true
                                 :additional-information true
                                 :analysis true
                                 :recommended-analysis (-> selected-question
                                                           :analyses
                                                           count
                                                           pos?
                                                           not)})]
      [:<>
       [:div.recommend-analysis--content
        [:div.my-0.is-align-items-flex-start.level-left
         [:div.is-flex-grow-1
          [:f> recommendations/ProcessSteps
           "Fill your response with the Selected Answer"
           [:div
            [:p [:b "Step " ((or step-fn identity) 3) ":"]
             " Choose the parts of the question to fill your response"]
            [:p "Choose from the list of other questions and answers, that we will use to build this response from."]]
           "Build Answer from Similar Analysis"
           :recommended-analysis-process
           [(when-not step-fn
             {:class :is-secondary
             :on-click #(do
                          (set-selected-question nil)
                          (set-selected-analysis nil))})
            {:class :is-secondary
             :on-click #(set-selected-question nil)}
            {:class :is-info}]]]]
        [:div.recommender--step.level-left
         [:button.button.is-secondary.mr-4.mt-2
          {:on-click #(set-selected-question nil)}
          [:i.icon.fas.fa-caret-left]]
         [:f> recommendations/SelectedQuestion->Response
          {:step-number ((or step-fn identity) 3)
           :step-fn step-fn
           :question question
           :on-question-selected on-question-selected
           :selected-question (-> selected-question
                                  (set/rename-keys {:question-content :content
                                                    :question-id :id})
                                  (assoc :analyses selected-question-analysis))
           :already-linked-construct-ids preselected-construct-ids
           :recommended-analyses recommended-analyses
           :all-analyses all-analysis
           :checked checked
           :set-checked set-checked
           :answer-options answer-options
           :set-answer-options set-answer-options}]]]
       [recommendations/Footer
        all-analysis
        (-> question :selected-answer :applied-analyses)
        checked
        selected-question
        on-submit
        answer-options]]))

;; ----------------------------------------------------------------------------
;;  Recommend Analysis : Controller
;; ----------------------------------------------------------------------------

  (defn recommend-analysis
    "Recommend Similar Analysis
     In order to recommend analysis, we require a reference question as well as
     handler that will add the various components of the end result selection
     to the answer for the reference question.

     All re-frame state is handled internally via analysis.search getters
     and setters, and is saved to [:analysis-search :questions (:id question)]

     Accepts a map with keys:
     - question - a question entity
     - on-submit - an arity-2 function that accepts arguments:
                   - coll - a collection of analysis structures to be added to an
                            answer
                   - answer-data - a map containing maybe keys:
                                   - response
                                   - additional-information"
    [{:keys [on-submit question]}]
    (let [path [:analysis-search :questions (:id question)]
          all-analysis @(analysis.search/all-analysis-structures)
          search-query @(analysis.search/get-search-query* path (:content question))
          search-context @(analysis.search/get-search-query-context*
                           path
                           (->> (mapv :content (:tree/ancestor-nodes question))
                                (interpose " : ")
                                (apply str)))

          selected-analysis @(analysis.search/get-selected-analysis* (conj path :recommended-analysis))
          set-selected-analysis (partial analysis.search/set-selected-analysis (conj path :recommended-analysis))

          selected-question @(analysis.search/get-selected-question* (conj path :recommended-analysis))
          set-selected-question (partial analysis.search/set-selected-question (conj path :recommended-analysis))

          [use-hierarchy-context set-use-hierarchy-context] (react/useState (boolean (seq search-context)))
          preselected-construct-ids (->> question
                                         :selected-answer
                                         :applied-analyses
                                         (remove :next-version-id)
                                         (mapv :construct-id)
                                         set)
          [checked set-checked] (react/useState
                                 (->> question
                                      :analyses
                                      (mapv #(select-keys % [:construct-id
                                                             :version-id]))
                                      set))
          on-question-selected (fn [q]
                                 (set-selected-question q)
                                 (set-checked
                                  (->> q
                                       :analyses
                                       (mapv #(select-keys % [:construct-id
                                                              :version-id]))
                                       set)))

          construct-id (:construct-id selected-analysis)
          linked-answers (when selected-analysis
                           @(applied.db/linked-answers* (:construct-id selected-analysis)))
          analyses-with-answers (->> all-analysis
                                     (filterv (fn [{:keys [applied-analyses]}]
                                                (->> applied-analyses
                                                     (mapv (comp vec :answer-ids))
                                                     flatten
                                                     seq
                                                     boolean))))
          parent-children (->> analyses-with-answers
                               (group-by :parent-id)
                               (mapv (fn [[k v]] [k (mapv :construct-id v)]))
                               (into {}))
          analyses-with-answers (->> analyses-with-answers
                                     (mapv
                                      (fn [{:keys [construct-id] :as asa}]
                                        (assoc asa :tree/children
                                               (get parent-children construct-id)))))
          selected-question-analysis (when selected-question
                                       @(analysis.db/answer-id->structured-analysis*
                                         (:answer-id selected-question)))
          on-set-use-hierarchy-context (fn []
                                         (analysis.search/debounced-search
                                          {:mode :semantic
                                           :path path
                                           :context (when (not use-hierarchy-context)
                                                      (->> (mapv :content (:tree/ancestor-nodes question))
                                                           (interpose " : ")
                                                           (apply str)))
                                           :set-query (partial analysis.search/set-search-query path)
                                           :set-loading identity}
                                          search-query)
                                         (set-use-hierarchy-context not))
          props {:selected-analysis selected-analysis
                 :analyses-with-answers analyses-with-answers
                 :linked-answers linked-answers
                 :path path
                 :on-question-selected on-question-selected
                 :set-selected-analysis set-selected-analysis
                 :selected-question selected-question
                 :selected-question-analysis selected-question-analysis
                 :recommended-analyses (-> (analysis.search/get-search-results* path)
                                           deref
                                           :structures)
                 :set-selected-question set-selected-question
                 :preselected-construct-ids preselected-construct-ids
                 :question question
                 :use-hierarchy-context use-hierarchy-context
                 :set-use-hierarchy-context on-set-use-hierarchy-context
                 :all-analysis all-analysis
                 :checked checked
                 :set-checked set-checked
                 :on-submit on-submit}]

      (react/useEffect
       (fn [] (applied.db/get-linked-answers construct-id)
         (fn [] 0))
       #js [construct-id])

      (react/useEffect
       (fn [] (set-checked (->> selected-question-analysis
                                (mapv #(-> (select-keys % [:construct-id
                                                           :version-id])
                                           (assoc :source :analysis)))
                                set))
         (fn [] 0))
       #js [selected-question-analysis])

      [:div.recommend-question
       (cond
         (and (not selected-analysis) (not selected-question))
         [RecommendAnalysis-1-SelectAnalysis props]
         (and selected-analysis (not selected-question))
         [RecommendAnalysis-2-SelectAnswerWithAppliedSelectedAnalysis props]
         :else
         [:f> RecommendAnalysis-3-FillAnswerWithSelectedQuestion props])]))



;; Analysis Answer View for Already Associated Analysis

(defn LinkedAnalysisAnswers
  "Linked Analysis
   Once an ASA has been added to a question answer, we provide a utility
   which allows content (response, comment, associated/recommended analysis)
   to be added to the given question, based on a response.

   Internally, we accept the chosen-analysis ASA as a 'selected' analysis,
   and iterate through steps 2 and 3 of the recommendation process.

   All re-frame state is handled internally via analysis.search getters
   and setters, and is saved to [:analysis-search :questions (:id question)

   Accepts a map with keys:
   - chosen-analysis - an analysis structure to display the answers for.
   - question - a question entity
   - on-submit - an arity-2 function that accepts arguments:
                 - coll - a collection of analysis structures to be added to an
                          answer
                 - answer-data - a map containing maybe keys:
                                 - response
                                 - additional-information"
  [{:keys [on-submit question chosen-analysis]}]
  (let [all-analysis @(analysis.search/all-analysis-structures)
        path [:analysis-search :questions (:id question)]
        [selected-analysis set-selected-analysis] (react/useState chosen-analysis)
        [selected-question set-selected-question] (react/useState nil)
        preselected-construct-ids (->> question
                                       :selected-answer
                                       :applied-analyses
                                       (remove :next-version-id)
                                       (mapv :construct-id)
                                       set)
        [checked set-checked] (react/useState
                               (->> question
                                    :analyses
                                    (mapv #(select-keys % [:construct-id
                                                           :version-id]))
                                    set))
        on-question-selected (fn [q]
                               (set-selected-question q)
                               (set-checked
                                (->> q
                                     :analyses
                                     (mapv #(select-keys % [:construct-id
                                                            :version-id]))
                                     set)))

        construct-id (:construct-id selected-analysis)
        linked-answers (when selected-analysis
                         @(applied.db/linked-answers* construct-id))
        analyses-with-answers (->> all-analysis
                                   (filterv (fn [{:keys [applied-analyses]}]
                                              (->> applied-analyses
                                                   (mapv (comp vec :answer-ids))
                                                   flatten
                                                   seq
                                                   boolean))))
        parent-children (->> analyses-with-answers
                             (group-by :parent-id)
                             (mapv (fn [[k v]] [k (mapv :construct-id v)]))
                             (into {}))
        analyses-with-answers (->> analyses-with-answers
                                   (mapv
                                    (fn [{:keys [construct-id] :as asa}]
                                      (assoc asa :tree/children
                                             (get parent-children construct-id)))))
        selected-question-analysis (when (:answer-id selected-question)
                                     @(analysis.db/answer-id->structured-analysis*
                                       (parse-uuid (str (:answer-id selected-question)))))
        props {:selected-analysis selected-analysis
               :analyses-with-answers analyses-with-answers
               :linked-answers linked-answers
               :on-question-selected on-question-selected
               :set-selected-analysis set-selected-analysis
               :selected-question selected-question
               :selected-question-analysis selected-question-analysis
               :recommended-analyses (-> (analysis.search/get-search-results* path)
                                         deref
                                         :structures)
               :set-selected-question set-selected-question
               :preselected-construct-ids preselected-construct-ids
               :question question
               :all-analysis all-analysis
               :checked checked
               :set-checked set-checked
               :on-submit on-submit
               :step-fn dec}]

    (react/useEffect
     (fn [] (applied.db/get-linked-answers construct-id)
       (fn [] 0))
     #js [construct-id])

    [:div.recommend-question
     (cond
       (not selected-question)
       [RecommendAnalysis-2-SelectAnswerWithAppliedSelectedAnalysis props]
       :else
       [:f> RecommendAnalysis-3-FillAnswerWithSelectedQuestion props])]))
